import { Box, Title } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { LicenseForm } from '../components/LicenseForm';

export const AddLicense = () => {
  const { keyId } = useParams();

  if (!keyId) {
    return <Box>Missing keyId</Box>;
  }

  return (
    <Box>
      <Title order={3} mb={12}>
        Add new license
      </Title>
      <LicenseForm keyId={keyId} license={null} />
    </Box>
  );
};
